<!--
통관발생비용 과금 모달 컴포넌트
------------------------------------
사용: app.$refs['charge-customs-cost'].form(houseId, userId, houseInfo)
디자인 참조: charge-shipping-etc-cost.vue
특이: 과금 전용 (환불 없음), 비용명칭/비용/VAT/최종금액 입력
-->
<template>
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical" style="width: 640px">

            <div class="uk-modal-header">
                <h4 class="uk-text-center" style="margin: 0;">통관발생비용 과금</h4>
            </div>

            <div class="uk-modal-body" style="padding: 24px 30px;">

                <!-- 하우스 정보 카드 -->
                <div v-if="house.code"
                     style="background: #f8fafc; border: 1px solid #edf2f7; border-radius: 10px; padding: 18px 20px; margin-bottom: 16px;">
                    <div style="font-weight: 600; color: #718096; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #edf2f7;">
                        하우스 정보
                    </div>
                    <div class="uk-grid uk-grid-small uk-child-width-1-2" uk-grid>
                        <div>
                            <app-column header="배송코드" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ house.code }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="수취인" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ house.name || '-' }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="송장번호" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ house.blno || '-' }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="HAWB" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ house.hawb || '-' }}
                            </app-column>
                        </div>
                    </div>
                </div>

                <!-- 회원 정보 카드 -->
                <div v-if="member.nick"
                     style="background: #f8fafc; border: 1px solid #edf2f7; border-radius: 10px; padding: 18px 20px; margin-bottom: 24px;">
                    <div style="font-weight: 600; color: #718096; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #edf2f7;">
                        회원 정보
                    </div>
                    <div class="uk-grid uk-grid-small uk-child-width-1-2" uk-grid>
                        <div>
                            <app-column header="회원사" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                {{ member.nick }}
                            </app-column>
                        </div>
                        <div>
                            <app-column header="결제수단" header-size="medium" body-size="medium"
                                header-align="left" body-align="left" horizontal header-width="70px">
                                <span style="display: inline-flex; align-items: center; gap: 6px; background: #f7fafc; border: 1px solid #e2e8f0; border-radius: 6px; padding: 2px 10px; font-size: 0.9rem;">
                                    <span style="width: 7px; height: 7px; border-radius: 50%; background: #48bb78; flex-shrink: 0;"></span>
                                    <span v-text="member.pm_label"></span>
                                </span>
                            </app-column>
                        </div>
                    </div>
                </div>

                <!-- 과금 정보 섹션 -->
                <div style="font-weight: 600; color: #4a5568; margin-bottom: 16px; padding-bottom: 10px; border-bottom: 2px solid #edf2f7;">
                    과금 정보
                </div>

                <!-- 비용명칭 -->
                <div class="uk-margin">
                    <label class="uk-form-label">비용명칭</label>
                    <div class="uk-form-controls">
                        <input class="uk-input" type="text"
                               v-model="inputs.name"
                               placeholder="e.g. 일반통관수수료">
                    </div>
                </div>

                <!-- 비용(KRW) -->
                <div class="uk-margin">
                    <label class="uk-form-label">비용 (KRW)</label>
                    <div class="uk-form-controls">
                        <input class="uk-input" type="text"
                               v-model="inputs.cost"
                               @input="onAmountInput"
                               placeholder="공급가액">
                    </div>
                </div>

                <!-- VAT(KRW) -->
                <div class="uk-margin">
                    <label class="uk-form-label">VAT (KRW)</label>
                    <div class="uk-form-controls">
                        <input class="uk-input" type="text"
                               v-model="inputs.vat"
                               @input="onAmountInput"
                               placeholder="부가세">
                    </div>
                </div>

                <hr />

                <!-- 최종 통관발생비용(KRW) -->
                <div class="uk-margin">
                    <label class="uk-form-label">최종 통관발생비용 (KRW)</label>
                    <div class="uk-form-controls">
                        <input class="uk-input" type="text"
                               v-model="inputs.customs_cost"
                               @input="onAmountInput"
                               placeholder="이 금액이 과금처리 됩니다">
                    </div>
                </div>

                <hr />

                <!-- 비고 -->
                <div class="uk-margin">
                    <label class="uk-form-label">비고</label>
                    <div class="uk-form-controls">
                        <textarea class="uk-textarea" rows="3"
                                  v-model="inputs.memo"
                                  placeholder="수동과금 사유를 입력하세요"></textarea>
                    </div>
                </div>

                <!-- 결제 요약 -->
                <div v-if="customsCost > 0"
                     style="border-radius: 10px; padding: 18px 20px; margin-top: 20px; border: 1px solid #e2e8f0; background: #f7fafc;">
                    <div style="font-weight: 600; margin-bottom: 14px; padding-bottom: 10px; border-bottom: 1px solid #e2e8f0;">
                        결제 요약
                    </div>
                    <div class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span>기본과금액</span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(customsCost) }} 원</span>
                    </div>
                    <div v-if="isCard" class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span>카드수수료 ({{ feeRatePercent }}%)</span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(feeAmount) }} 원</span>
                    </div>
                    <div v-if="isCard" class="uk-flex uk-flex-between" style="padding: 6px 0; color: #718096;">
                        <span>카드수수료 부가세</span>
                        <span style="color: #2d3748; font-weight: 500;">{{ numberFormat(feeVatAmount) }} 원</span>
                    </div>
                    <div class="uk-flex uk-flex-between"
                         style="border-top: 2px solid #bee3f8; margin-top: 10px; padding-top: 12px; font-weight: 700; font-size: 1.1rem;">
                        <span>최종 결제금액</span>
                        <span style="color: #1e87f0;">{{ numberFormat(totalAmount) }} 원</span>
                    </div>
                </div>

                <!-- 에러 메시지 -->
                <div v-if="errorMsg" class="uk-alert uk-alert-danger" style="margin-top: 16px;">
                    {{ errorMsg }}
                </div>
            </div>

            <div class="uk-modal-footer uk-text-right">
                <button type="button"
                        class="uk-button uk-button-default uk-modal-close">
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button type="button"
                        class="uk-button uk-button-primary"
                        :disabled="submitting"
                        @click="submit()">
                    <span uk-icon="icon: check"></span>
                    과금 실행
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            csrfToken: String,
            cardFeeRate: { type: Number, default: 0.035 },
        },
        data: function () {
            return {
                member: {},
                house: {},
                houseId: null,
                userId: null,
                inputs: {
                    name: '',
                    cost: '',
                    vat: '',
                    customs_cost: '',
                    memo: '',
                },
                customsCost: 0,
                errorMsg: '',
                submitting: false,
            };
        },
        computed: {
            isCard: function () {
                return this.member.is_card || false;
            },
            feeRatePercent: function () {
                return parseFloat((this.cardFeeRate * 100).toFixed(2));
            },
            feeAmount: function () {
                return this.isCard ? Math.floor(this.customsCost * this.cardFeeRate) : 0;
            },
            feeVatAmount: function () {
                return this.isCard ? Math.floor(this.feeAmount * 0.1) : 0;
            },
            totalAmount: function () {
                return this.customsCost + this.feeAmount + this.feeVatAmount;
            },
        },
        methods: {
            form: function (house_id, user_id, house_info) {
                this.houseId = house_id;
                this.userId = user_id;
                this.house = house_info || {};
                this.inputs = { name: '', cost: '', vat: '', customs_cost: '', memo: '' };
                this.customsCost = 0;
                this.member = {};
                this.errorMsg = '';
                this.submitting = false;

                var self = this;
                var loadUser = new Promise(function (resolve) {
                    $.app.ajax.module.background({
                        type: 'get',
                        url: '/company-users/' + user_id,
                        contentType: 'application/json',
                        data: {},
                        success: function (response) { resolve(response); },
                    });
                });

                var loadMemberData = new Promise(function (resolve) {
                    $.app.ajax.module.background({
                        type: 'get',
                        url: '/admin/billings/manual-charge/member-data/' + user_id,
                        contentType: 'application/json',
                        data: {},
                        success: function (response) { resolve(response); },
                    });
                });

                Promise.all([loadUser, loadMemberData]).then(function (results) {
                    var userResponse = results[0];
                    var memberData = results[1];

                    self.member = {
                        nick: userResponse.user.nick,
                        pm_label: memberData.pm_label,
                        is_card: memberData.is_card,
                    };

                    UIkit.modal(self.$el).show();
                });
            },

            onAmountInput: function () {
                this.customsCost = parseInt(this.inputs.customs_cost) || 0;
            },

            submit: function () {
                if (this.customsCost < 1) {
                    this.errorMsg = '최종 통관발생비용은 최소 1원 이상이어야 합니다.';
                    return;
                }

                this.errorMsg = '';
                this.submitting = true;

                var self = this;
                var load = new Promise(function (resolve, reject) {
                    $.app.ajax.module.default({
                        type: 'post',
                        url: '/houses/' + self.houseId + '/customs-costs',
                        data: {
                            '_token': self.csrfToken,
                            'name': self.inputs.name,
                            'cost': self.inputs.cost,
                            'vat': self.inputs.vat,
                            'customs_cost': self.inputs.customs_cost,
                            'memo': self.inputs.memo,
                        },
                        success: function (response) { resolve(response); },
                        error: function (jqXHR) { reject(jqXHR); },
                    });
                });

                load.then(function (response) {
                    UIkit.modal(self.$el).hide();
                    UIkit.modal.alert(response.msg).then(function () {
                        $.app.refresh();
                    });
                }).catch(function (jqXHR) {
                    self.submitting = false;

                    if (jqXHR.status === 422 && jqXHR.responseJSON) {
                        var errors = jqXHR.responseJSON;
                        var msgs = [];
                        for (var field in errors) {
                            if (Array.isArray(errors[field])) {
                                msgs.push(errors[field][0]);
                            }
                        }
                        self.errorMsg = msgs.join('\n') || '입력값을 확인하세요.';
                    } else if (jqXHR.responseJSON && jqXHR.responseJSON.msg) {
                        self.errorMsg = jqXHR.responseJSON.msg;
                    } else {
                        self.errorMsg = '요청 처리 중 오류가 발생했습니다.';
                    }
                });
            },

            numberFormat: function (num) {
                return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
        },
    };
</script>
